/* eslint prefer-template: 0 */
const getHumanMetaTitle = (page, name) => {
    const titleConfig = {
        form: 'Record By Race Type',
        entries: 'Historical Race Entries',
        'booked-rides': 'Booked Rides',
        horses: 'Horse Records',
        stats: 'Statistical Summary',
    };

    const title = `${name} | ${titleConfig[page]} | Racing Post`;

    window.pageTitle = title;

    return title;
};

const getHumanMetaDescription = (type, page, name) => {
    const descriptionConfig = {
        jockey: {
            form:
                `Jockey ${name} statistics and form.
                View results and future entries as well as statistics by course,
                race type and prize money.`,
            'booked-rides':
                `View upcoming rides for Jockey ${name}.
                With unparalleled statistics including wins,
                earnings and much, much more.`,
            horses:
                `Jockey ${name} historical horse records.
                Data includes runs, wins, RPR, winnings and earnings.
                Drill down by race type and time by using the filter option.`,
            stats:
                `Statistical summary of results for Jockey ${name}.
                Filter results by race type, check out win ratios,
                total prize money won plus much, much more.`,
        },
        trainer: {
            form:
                `Trainer ${name} statistics and form.
                View results and future entries as well as statistics by course,
                race type and prize money.`,
            entries:
                `Forthcoming entries for trainer ${name}.
                Includes date entered, race time and latest betting odds.`,
            horses:
                `${name}'s historical horse records.
                Data includes runs, wins, RPR, winnings and earnings.`,
            stats:
                `Statistical summary of results for trainer ${name}.
                Filter results by race type, check out win ratios,
                total prize money won plus much, much more.`,
        },
        owner: {
            form:
                `Owner ${name} statistics and form.
                View results and future entries as well as statistics by course,
                race type and prize money.`,
            entries:
                `Historical race entries for owner ${name}.
                A comprehensive list of entries for the last five seasons.
                Access win ratios, total prize money won, RPR and much more.`,
            horses:
                `${name}'s historical horse records.
                Filter by race type and time period.
                Data includes runs, wins, RPR, winnings and earnings.`,
            stats:
                `Statistical summary of results for owner ${name}.
                Filter results by race type, check out win ratios,
                total prize money won plus much, much more.`,
        },
    };

    return descriptionConfig[type][page];
};

const getHumanMetaData = (type, page, name) => ({
    title: getHumanMetaTitle(page, name),
    description: getHumanMetaDescription(type, page, name),
});

export default getHumanMetaData;




// WEBPACK FOOTER //
// ./src/js/shared/metaData/getHumanMetaData.js